<div class="edit-picture-container">
  <p>Upload Profile Image</p>
  <input style="display: none" type="file" (click)="fileInput.value = ''" (change)="onFileChanged($event)" #fileInput />

  @if (profileImage) {
    <div class="confirm-wrapper">
      <div class="image-div">
        <img class="group-image" [src]="profileImage" alt="User Generated Image" />
        <button
          mat-fab
          class="remove-button"
          [matTooltip]="'Delete Profile Picture'"
          (click)="deleteImage()"
          [disabled]="isDisabled()"
        ></button>
      </div>
      <button type="button" [disabled]="isDoneDisabled" class="button-confirm-picture" (click)="closeModal()">
        Done
      </button>
    </div>
  } @else {
    <div class="upload-wrapper">
      <div class="add-image" (click)="fileInput.click()" aria-label="Add Image Button">
        <img src="assets/images/new_upload_icon.svg" class="upload-icon" width="125" />
        <span class="description">Select file to upload. <strong>Browse</strong></span>
      </div>
    </div>
  }
</div>
